import type { SyntheticEvent } from 'react';

const stopPropagation = (callback: (e: SyntheticEvent) => void) => {
	return (e: SyntheticEvent) => {
		e.preventDefault();
		e.stopPropagation();

		callback(e);
	};
};

export default stopPropagation;
